export var TooltipPosition;
(function (TooltipPosition) {
    TooltipPosition["Bottom"] = "bottom";
    TooltipPosition["Top"] = "top";
    TooltipPosition["Left"] = "left";
    TooltipPosition["Right"] = "right";
})(TooltipPosition || (TooltipPosition = {}));
//# sourceMappingURL=CsTooltip.js.map